module.exports = __webpack_public_path__ + "static/img/meet-the-team_3.723bd3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/meet-the-team_3.png
// module id = ruPO
// module chunks = 0